module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-right"
  }, [_c('span', [_c('i', [_vm._v("Have you heard")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-right1"
  }, [_c('span', [_c('i', [_vm._v("That silence where the birds are dead yet something")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-right1"
  }, [_c('span', [_c('i', [_vm._v("pipeth like a bird?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0